import React, { Component } from 'react';
// import resultData from '../data/resultProduct.json';
// import resultData from '../data/resultData.json';
import Product from './product';
import ProductDetail from './productDetail';
import ReactGA from 'react-ga4';

class Result extends Component {

    // constructor(props) {
	// 	super(props);
	// }

    state = {
        resultData: '',
        product: '',
        rowHeight: '',
    }

    componentDidMount() {
        const urlSearchString = window.location.search;
        const params = new URLSearchParams(urlSearchString);

        const url = `${this.props.host}?id=${this.props.pageUid}&type=1699552000&tx_fixitgruppe_productfindertreeresults[pageUid]=${this.props.aUid}`

        // console.log(url);
        fetch(url)
        .then((response) => response.json())
        .then((data) => {
            this.setState({ resultData: data })
            
            if (this.props.ignoreParams){
                // console.log('Params(if) ' + this.props.ignoreParams)
                // urlSearchString.params.set('p', 0);
                // console.log('test: '+params.get('p'))
                params.set('a', this.props.aUid);
                params.set('p', 0);
                window.history.pushState({},'','?'+params)
                
            } else {
                // console.log('Params(else) ' + this.props.ignoreParams)
                if (params.get('p')){
                    // console.log('1');
                    let pUid = Number.parseInt(params.get('p'));
                    let prod = data['products'].find(o => o.product.uid === pUid);
                    // console.log(prod)
                    if (prod === undefined) {
                        // console.log('Kein Produkt gefunden!')
                        this.props.changeView('RL');
                        if (pUid !== 0) {
                            // console.log(pUid);
                            this.setState({ error: true });
                        } else {
                            // console.log('2')
                            //params.set('p', 0);
                            // window.location.params.set('p', 0);
                        }
                    } else {
                        // console.log('Produkt gefunden!')
                        this.productDetail(prod);
                    }
                } else {
                    // console.log('testawdf')
                    params.set('p', 0);
                    window.history.pushState({},'',params)
                }
            }
        })
        .catch((error) => {
            // console.log(error);
            this.setState({ error: true })
        });
    }

    productDetail = (item) => {
        this.setState({ product: item });
        this.setState({ error: false });
        this.props.changeView('RD');
        const params = new URLSearchParams(window.location.search);
        if (params.get('p') === '0') {

            // TRACKING
            // console.log('product_finder_product_click');
            // console.log('item_name: ' + item.product.title + '');
            // console.log('item_id: ' + item.product.uid + '');
            ReactGA.event('product_finder_product_click', {
                'item_name': item.product.title,
                'item_id': item.product.uid
            });
        }
        params.set('p', item.product.uid);
        window.history.pushState({},'','?'+params)
    }

    updateView = (newValue) => {
        this.setState({ view: newValue });
        this.props.changeView({ view: newValue });
        // this.setState({ result: true })
    }

    updateHeight = (newValue, index, firstCardH) => {
        if (index >= 3){
            this.setState({ rowHeight: newValue +  firstCardH + 30});
        } else {
            this.setState({ rowHeight: newValue });
        }
    }

    render () {        
        const divHeight = {
            minHeight: this.state.rowHeight + 30
        };

        return (
            <>
                {this.state.resultData ? (
                <div className='row result'> 
                    {this.props.view === 'RD' ? (
                        <>
                            <div className='col-12 question'>
                                {this.state.resultData.title.length 
                                    ? <h2>{this.state.resultData.title}</h2>
                                    : <h2>Ihre Produktauswahl</h2>
                                }
                            </div> 
                            <div className='product-detail'>
                                <ProductDetail 
                                    item={this.state.product} 
                                    result={this.state.resultData}
                                    appData={this.props.appData}
                                    aUid={this.props.aUid}
                                    />
                            </div>
                        </>
                    ) : (
                        <>
                            {this.state.error 
                                ? <div className='col-12 error-message'>{this.props.appData.productfinder_error_product}</div>
                                : ''
                            }
                            
                            <div className='col-12 question'>
                                {this.state.resultData.title.length 
                                    ? <h2>{this.state.resultData.title}</h2>
                                    : <h2>Ihre Produktauswahl</h2>
                                }
                            </div>
                            <div className='col-12 result-items' style={divHeight}>
                                <div className='row'>
                                    {this.state.resultData.products.map((item, index) => (
                                        <Product 
                                            index={index}
                                            key={item.product.uid} 
                                            item={item}
                                            view={this.state.view}
                                            changeView={this.updateView}
                                            showDetail={() => this.productDetail(item)}
                                            updateRowHeight={this.updateHeight} />
                                    ))}
                                </div>
                            </div>
                        </>
                    )}
                </div>
                ):(
                    <>
                    {this.state.error 
                        ? <span className='error'>{this.state.appData.productfinder_error}</span>
                        : (
                            <div className='row'>
                                <div className='col-12'>
                                    <div className="lds-ring">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    </>
                )}
            </>
        );
    }
}

export default Result;